import { Article } from '@web/types/Article'

export default class ClubMaterialsApi {
  /**
   * Поиск по материалам клуба.
   *
   * ЗАГЛУШКА: инфраструктуры поиска на club-backend пока нет (эпик SEARCH-HOME,
   * открытый вопрос E). Сигнатура совпадает с будущим реальным эндпоинтом —
   * подмена на бэкенд затрагивает только тело этого метода.
   *
   * @param textSearch {string} - Текст для поиска
   * @param page {number} - Номер страницы (по умолчанию 1)
   * @param perPage {number} - Элементов на странице (по умолчанию 8)
   * @returns {Promise<{ data: Article[]; headers: Headers }>}
   */
  static search (_: {
    textSearch?: string;
    page?: number;
    perPage?: number;
  }): Promise<{ data: Article[]; headers: Headers }> {
    // TODO(SEARCH-HOME/club): заменить на client.post('/club/materials/search', ...)
    return Promise.resolve({ data: [], headers: new Headers() })
  }
}
